<div class="container">
  <div class="table-header">
    <div class="table-title">
      <div class="table-icon">
        <i nz-icon nzType="file-text"></i>
      </div>
      <div class="table-name">
        <span>SOP Report Mapping</span>
      </div>
    </div>
    <div class="table-action-controls">
      <div class="table-action-filter">
        <nz-input-group [nzPrefix]="prefixIconSearch" [nzSuffix]="SuffixIconSearch">
          <input
            (input)="onSearch($event)"
            nz-input
            placeholder="Search"
            style="width: 300px"
            type="text"
          />
        </nz-input-group>
        <ng-template #prefixIconSearch>
          <i nz-icon nzType="search"></i>
        </ng-template>
        <ng-template #SuffixIconSearch>
          <i
            nz-icon
            nzType="table"
            (click)="toggleColumnFilters()"
            [ngClass]="{ 'ant-filter-active': showColumnFilters }"
            style="cursor: pointer"
          ></i>
        </ng-template>
      </div>
      <div class="table-action-create">
        <button (click)="showModal()" nz-button nzType="primary">
          <b><span nz-icon nzType="plus"></span></b>New
        </button>
      </div>
      <div class="table-action-refresh">
        <button (click)="getSOPReport()" nz-button><span nz-icon nzType="sync"></span></button>
      </div>
      <div class="table-action-settings">
        <button nz-button><span nz-icon nzType="setting"></span></button>
      </div>
      <div class="table-action-dropdown">
        <button nz-button><span nz-icon nzType="menu"></span></button>
      </div>
    </div>
  </div>
</div>

<div class="table-body">
  <nz-table
    #basicTable
    [nzData]="filteredData"
    [nzScroll]="{ y: tableHeight + 'px' }"
    [nzShowPagination]="false"
    nzSize="small"
    style="border: solid 1px #e6e6e6; border-bottom: none"
  >
    <thead style="padding: 5px">
      <tr>
        <th [nzSortFn]="sortSopReportCode" nzShowSort nzWidth="30%" style="color: #777">
          SOP Report Name
        </th>
        <th nzWidth="20%"></th>
      </tr>
      <tr *ngIf="showColumnFilters">
        <th>
          <input
            nz-input
            (input)="updateColumnFilter('sopReportName', $event)"
            [value]="columnFilters['sopReportName'] || ''"
            placeholder="Filter name..."
          />
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of filteredData">
        <td style="border-bottom: none">
          <a>{{ item.sopReportName }}</a>
        </td>
        <td style="border-bottom: none">
          <div class="action-button">
            <i
              (nzOnConfirm)="deleteSOPReport(item.id)"
              nz-icon
              nz-popconfirm
              nzCancelText="Cancel"
              nzOkText="Yes"
              nzOkType="primary"
              nzPopconfirmPlacement="bottom"
              nzPopconfirmTitle="Are you sure to delete?"
              nzType="delete"
            ></i>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <div *ngIf="!filteredData?.length" style="padding: 20px; text-align: center; color: #999;">
    No data to display!
  </div>
</div>

<div class="footer">
  <div class="data-count" style="margin-left: 10px">
    {{ filteredData?.length || 0 }} Records
  </div>
</div>

<nz-modal
  (nzOnCancel)="handleCancel()"
  [(nzVisible)]="isVisible"
  [nzFooter]="modalFooter"
  [nzOkLoading]="isOkLoading"
  [nzTitle]="isEditMode ? 'Edit SOP Report Mapping' : 'Add SOP Report Mapping'"
  nzWidth="50%"
>
  <form [formGroup]="sopReportForm">
    <div *nzModalContent class="sopReportForm">
      <div
        nz-row
        nzGutter="16"
        style="display: flex; flex-wrap: wrap; justify-content: space-between"
      >
        <div [nzSpan]="24" nz-col style="margin-bottom: 15px">
          <label><span style="color: red;">*</span> SOP Report</label>
          <nz-select
            formControlName="sopReportId"
            nzPlaceHolder="Select SOP Report"
            nzShowSearch
            style="width: 100%"
          >
            <nz-option
              *ngFor="let report of sopReports"
              [nzLabel]="report.code + ' - ' + report.name"
              [nzValue]="report.id"
            ></nz-option>
          </nz-select>
        </div>
      </div>
    </div>
  </form>
</nz-modal>

<ng-template #modalFooter>
  <div style="display: flex; justify-content: flex-end; gap: 5px; padding: 5px">
    <button (click)="handleSave()" nz-button nzType="primary" [nzLoading]="isOkLoading" [disabled]="isSaveDisabled">
      <i nz-icon nzType="save" style="margin-right: 5px"></i> Save
    </button>
    <button (click)="handleCancel()" nz-button nzType="default">Cancel</button>
  </div>
</ng-template>